import React from "react";
import { initials } from "./reportingStyles";

function Avatar({ name, size = 32 }) {
  const px = `${size}px`;
  return (
    <div
      className="flex shrink-0 items-center justify-center rounded-full bg-indigo-50 font-semibold text-indigo-700"
      style={{ width: px, height: px, fontSize: Math.round(size * 0.36) }}
      aria-hidden="true"
    >
      {initials(name)}
    </div>
  );
}

export default Avatar;